import { render } from "./freeze-unfreeze-popup.vue?vue&type=template&id=64cbbf0a&scoped=true&ts=true"
import script from "./freeze-unfreeze-popup.vue?vue&type=script&lang=ts"
export * from "./freeze-unfreeze-popup.vue?vue&type=script&lang=ts"

import "./freeze-unfreeze-popup.vue?vue&type=style&index=0&id=64cbbf0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cbbf0a"]])

export default __exports__